import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Button,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

import { modalUpdatePersonalDataStyles } from './styles';

import { DATA_ROUTE, ADDRESS_ROUTE } from '../../../../../constants/Routes';

import { closeModalUpdatePersonalData } from '../../../../../redux/actions/ProfileActions';

import ositoIcon from '../../../../../assets/osito.svg';

const ModalUpdatePersonalData = (props) => {
  const { mobile } = props;
  const classes = modalUpdatePersonalDataStyles({ mobile });
  const history = useHistory();
  const dispatch = useDispatch();
  const { profile, openModalUpdatePersonalData } = useSelector(
    (state) => state.profileReducer,
  );

  const goToPersonalData = () => {
    dispatch(closeModalUpdatePersonalData());
    history.push(DATA_ROUTE);
  };

  const goToAddresses = () => {
    dispatch(closeModalUpdatePersonalData());
    history.push(ADDRESS_ROUTE);
  };

  const handleClose = () => {
    dispatch(closeModalUpdatePersonalData());
  };

  return (
    <React.Fragment>
      <div className={classes.container}>
        <Dialog
          data-cy="updatePersonalDataModal"
          onClose={handleClose}
          open={openModalUpdatePersonalData}
          maxWidth={'lg'}
          disableBackdropClick
          disableEscapeKeyDown
          classes={{
            paper: classes.paper,
          }}
        >
          <DialogTitle
            onClose={handleClose}
            className={classes.dialogTitleContainer}
          >
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleClose}
              data-cy={'closeModalUpdatePersonalData'}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent className={classes.normalText}>
            <Typography className={classes.imageContainer}>
              <img
                className={classes.image}
                src={ositoIcon}
                data-cy="updatePersonalDataImage"
              />
            </Typography>
            <Typography
              className={classes.title}
              data-cy="updatePersonalDataTitle"
            >
              {`${profile.firstName}, recuerda`}
            </Typography>
            <Typography
              className={classes.bodyText}
              data-cy="updatePersonalDataSubtitle"
            >
              <React.Fragment>
                Si actualizas tus datos personales, ayudarás a mejorar tu
                experiencia
              </React.Fragment>
            </Typography>
          </DialogContent>
          <DialogActions className={classes.dialogActionsContainer}>
            <Box display="flex" flexDirection="column">
              <Button
                variant="contained"
                color="primary"
                className={classes.updatePersonalDataButton}
                onClick={goToPersonalData}
                data-cy="updatePersonalDataButton"
              >
                Actualizar mis datos personales
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.updateAddressesButton}
                onClick={goToAddresses}
                data-cy="updateAddressesButton"
              >
                Actualizar mis direcciones
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

ModalUpdatePersonalData.propTypes = {
  mobile: PropTypes.bool,
};

export default ModalUpdatePersonalData;
